import * as React from 'react'
import CertificateType from '../../shared/types'
import { gotoDeepLink } from '../../shared/lib'
import BuyForm from '../buy-form'
import s from './index.module.scss'
import Certificate from '../../shared/ui/certificate'
import ExpandableText from '../../shared/ui/expandable-text'
import Button from '../../shared/ui/button'

interface Props {
    certificate: CertificateType | null
    giftGuid?: string
}
export default function MainPageBuyCertificate({ certificate, giftGuid }: Props) {
    if (certificate == null) {
        return <></>
    }

    return (
        <div className={s.container}>
            <h1>{certificate.greeting}</h1>

            <Certificate certificate={certificate} />

            <p>
                <b>{certificate.issuer_title}: </b> {certificate.issuer_name}
            </p>

            <ExpandableText title={certificate.description_title} text={certificate.description} />

            <BuyForm certificate={certificate} giftGuid={giftGuid} />

            <div className={s.mobileInfo}>
                <div className={s.separator}>
                    <div />
                    <span>{certificate.or_text}</span>
                </div>

                <Button className={s.btn} variant="danger" onClick={() => gotoDeepLink(certificate)}>
                    {certificate.text_button}
                </Button>

                <p className={s.ref}>{certificate.text_3}</p>
            </div>
        </div>
    )
}
